import script from "./ChartComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartComponent.vue?vue&type=script&setup=true&lang=js"

import "./ChartComponent.vue?vue&type=style&index=0&id=1d1a0bde&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d1a0bde"]])

export default __exports__